export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`]
];
